import React from "react";
import RoutePaths from "security-app/routing/Routes";
import EventsPageNavigation from "components/events/EventsPageNavigation";
import useLicenseCheck from "license/useLicenseCheck";
import { PAGE_NAVIGATION_TITLE } from "components/events/bindings";
import { DETECTION_CHAINS_TITLE } from "security-app/components/DetectionChains/constants";
import ExecuteEventProcedureActionPage from "security-app/pages/security-events/EventProcedureActionExecution";
import EventProcedures from "./index";
const EVENT_PROCEDURES_TITLE = "Event Procedures";
export default {
  routes: [
    {
      path: RoutePaths.unqualified.CORE_EVENTS.EVENT_PROCEDURES.LIST(":viewType"),
      component: () => /* @__PURE__ */ React.createElement(EventProcedures, { navigationComponent: /* @__PURE__ */ React.createElement(EventsPageNavigation, null) })
    },
    {
      path: RoutePaths.unqualified.CORE_EVENTS.EVENT_PROCEDURES.executeAction(),
      component: () => /* @__PURE__ */ React.createElement(ExecuteEventProcedureActionPage, null)
    }
  ],
  "pageNavigation": [
    {
      description: PAGE_NAVIGATION_TITLE,
      children: [
        {
          description: EVENT_PROCEDURES_TITLE,
          path: RoutePaths.CORE_EVENTS.EVENT_PROCEDURES.LIST("procedures"),
          permissions: [],
          position: { after: DETECTION_CHAINS_TITLE },
          useCondition: () => {
            const {
              security: { isValid: isValidSecurityLicense }
            } = useLicenseCheck();
            return isValidSecurityLicense;
          }
        }
      ]
    }
  ],
  "entityTypeRoute": [
    {
      type: "event_procedure",
      // TODO: No details page for event procedures yet
      route: (_id) => RoutePaths.CORE_EVENTS.EVENT_PROCEDURES.LIST("procedures")
    },
    {
      type: "event_procedure_step",
      // TODO: No details page for event procedure steps yet
      route: (_id) => RoutePaths.CORE_EVENTS.EVENT_PROCEDURES.LIST("procedures")
    }
  ]
};
